import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import _ from 'lodash'

import {
    negativeEventsLoadTableData,
    negativeEventsTableChange,
    negativeEventsLoadDistraintsHistory,
} from '../../actions'

import { setupDistraintsById } from '../../../../../../../../Distraints/actions'

function mapStateToProps(state, hocProps) {
    const id = _.get(hocProps, 'id', null)
    const block = _.get(hocProps, 'block', null)
    const module = _.get(hocProps, 'module', null)
    const tableId = `ne-execution-table-${id}`
    const tableSelector = 'executions'

    return {
        tableId,
        tableSelector,
        isLoading: state.getIn(
            ['ui', 'workspace', module, id, 'blocks', block, 'customData', tableId, 'isLoading'],
            false
        ),
        data: state.getIn(['ui', 'workspace', module, id, 'blocks', block, 'customData', tableId, 'data'], []),
        pagination: state.getIn(
            ['ui', 'workspace', module, id, 'blocks', block, 'customData', tableId, 'pagination'],
            {}
        ),
        filter: state.getIn(['ui', 'workspace', module, id, 'blocks', block, 'customData', tableId, 'filter'], {}),
        sorted: state.getIn(['ui', 'workspace', module, id, 'blocks', block, 'customData', tableId, 'sorted'], []),
        loaded: state.getIn(['ui', 'workspace', module, id, 'blocks', block, 'customData', tableId, 'loaded'], false),
        failed: state.getIn(['ui', 'workspace', module, id, 'blocks', block, 'customData', tableId, 'failed'], false),
        dataLocale: state.getIn(
            ['ui', 'workspace', module, id, 'blocks', block, 'customData', tableId, 'dataLocale'],
            null
        ),
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            negativeEventsLoadDistraintsHistory,
            negativeEventsLoadTableData,
            negativeEventsTableChange,
            setupDistraintsById,
        },
        dispatch
    )
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }
    return HocConnect
}
